import React from 'react';
import classnames from 'classnames';
import * as styles from './styles.module.scss';

import NewsList from '@/components/Elements/NewsList';
import Button from 'components/UI/Button';
import Icon from 'components/UI/Icon';
import useLocaleTxt from 'hooks/useLocaleTxt';

const News = ({ data }) => {
  const localeTxt = useLocaleTxt();

  return (
    <div>
      <h2 className={classnames('cr-h2', styles.news_title)}>{data.title}</h2>

      <div className={styles.news_list}>
        <NewsList news={data.list} />
      </div>

      <Button
        className={classnames(
          'cr-btn--icon cr-btn--large cr-btn--wide cr-btn--icon-red-txt'
        )}
      >
        {localeTxt['BLOG_READ_MORE']}
        <Icon name="corner-arrow-small-bold" />
      </Button>
    </div>
  );
};

export default News;
